import { mainnet, bsc, base, polygon, arbitrum, optimism } from 'wagmi/chains';
import { Token } from '../../api/DynaVaultsAPI';
import { TOKENS } from 'utils/constants/tokens';

interface NativeToken extends Omit<Token, 'address'> {
  chainId: number;
  buySFITokenHref: string;
  tokenGroup: 'stable' | 'bluechip' | 'altcoin';
  coingeckoId?: string;
}

export const nativeTokens: NativeToken[] = [
  {
    symbol: 'ETH',
    decimals: 18,
    name: 'Ether',
    chainId: mainnet.id,
    tokenGroup: 'bluechip',
    coingeckoId: 'ethereum',
    buySFITokenHref:
      'https://relay.link/bridge/ethereum?toCurrency=0x7636d8722fdf7cd34232a915e48e96aa3eb386bf&fromChainId=1&fromCurrency=0x0000000000000000000000000000000000000000',
  },
  {
    symbol: 'ETH',
    decimals: 18,
    name: 'Ether',
    chainId: base.id,
    tokenGroup: 'bluechip',
    coingeckoId: 'ethereum',
    buySFITokenHref:
      'https://aerodrome.finance/swap?from=eth&to=0x863B7364a29daA23C9FCBD02e27D129A8B185891&chain0=8453&chain1=8453',
  },
  {
    symbol: 'BNB',
    decimals: 18,
    name: 'BNB',
    chainId: bsc.id,
    tokenGroup: 'bluechip',
    coingeckoId: 'binancecoin',
    buySFITokenHref:
      'https://pancakeswap.finance/swap?chain=bsc&outputCurrency=0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF&inputCurrency=bnb',
  },
  {
    symbol: 'POL',
    decimals: 18,
    name: 'POL',
    chainId: polygon.id,
    tokenGroup: 'altcoin',
    coingeckoId: 'polygon-ecosystem-token',
    buySFITokenHref:
      'https://relay.link/bridge/ethereum?toCurrency=0x7636d8722fdf7cd34232a915e48e96aa3eb386bf&fromChainId=137&fromCurrency=0x0000000000000000000000000000000000000000',
  },
  {
    symbol: 'ETH',
    decimals: 18,
    name: 'Ether',
    chainId: arbitrum.id,
    tokenGroup: 'bluechip',
    coingeckoId: 'ethereum',
    buySFITokenHref:
      'https://relay.link/bridge/base?toCurrency=0x863b7364a29daa23c9fcbd02e27d129a8b185891&fromChainId=42161',
  },
  {
    symbol: 'ETH',
    decimals: 18,
    name: 'Ether',
    chainId: optimism.id,
    tokenGroup: 'bluechip',
    coingeckoId: 'ethereum',
    buySFITokenHref:
      'https://relay.link/bridge/base?toCurrency=0x863b7364a29daa23c9fcbd02e27d129a8b185891&fromChainId=10&fromCurrency=0x0000000000000000000000000000000000000000',
  },
];

export interface VaultToken extends Token {
  isDeposit: boolean;
  isStable: boolean;
  chainId: number;
  tokenGroup: 'stable' | 'bluechip' | 'altcoin';
  coingeckoId?: string;
}

export const vaultTokens: VaultToken[] = [
  {
    ...TOKENS.BNB.WBNB,
    isDeposit: true,
    isStable: false,
    chainId: bsc.id,
    tokenGroup: 'bluechip',
    coingeckoId: 'binancecoin',
  },
  {
    ...TOKENS.BNB.BTCB,
    isDeposit: true,
    isStable: false,
    chainId: bsc.id,
    tokenGroup: 'bluechip',
    coingeckoId: 'bitcoin',
  },
  {
    symbol: 'USDC',
    decimals: 6,
    name: 'USD Coin',
    address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    isDeposit: true,
    isStable: true,
    chainId: mainnet.id,
    tokenGroup: 'stable',
    coingeckoId: 'usd-coin',
  },
  {
    symbol: 'USDC',
    decimals: 6,
    name: 'USD Coin',
    address: '0x833589fcd6edb6e08f4c7c32d4f71b54bda02913',
    isDeposit: true,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
    coingeckoId: 'usd-coin',
  },
  {
    symbol: 'USDT',
    decimals: 6,
    name: 'Tether USD',
    address: '0xfde4c96c8593536e31f229ea8f37b2ada2699bb2',
    isDeposit: true,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
    coingeckoId: 'tether',
  },
  {
    symbol: 'WETH',
    decimals: 18,
    name: 'Wrapped Ether',
    address: '0x4200000000000000000000000000000000000006',
    isDeposit: true,
    isStable: false,
    chainId: 8453,
    tokenGroup: 'bluechip',
    coingeckoId: 'ethereum',
  },
  {
    symbol: 'cbBTC',
    decimals: 8,
    name: 'Coinbase Wrapped BTC',
    address: '0xcbb7c0000ab88b473b1f5afd9ef808440eed33bf',
    isDeposit: true,
    isStable: false,
    chainId: 8453,
    tokenGroup: 'bluechip',
    coingeckoId: 'bitcoin',
  },
  {
    symbol: 'EURC',
    decimals: 6,
    name: 'EURC',
    address: '0x60a3E35Cc302bFA44Cb288Bc5a4F316Fdb1adb42',
    isDeposit: true,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'bAutopilot_USDC',
    decimals: 8,
    name: 'Autopilot USDC Base',
    address: '0x0d877dc7c8fa3ad980dfdb18b48ec9f8768359c4',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'wsrarcV2USDC',
    decimals: 6,
    name: 'Wrapped Senior ArcadiaV2 USD Coin',
    address: '0xbc10718571fcb3c3f67800e7c0887e450d2ff398',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'aprUSDC',
    decimals: 18,
    name: 'Apostro Resolv USDC',
    address: '0xcddcdd18a16ed441f6cb10c3909e5e7ec2b9e8f3',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'CSUSDC',
    decimals: 18,
    name: 'Clearstar USDC Reactor',
    address: '0x1d3b1cd0a0f242d598834b3f2d126dc6bd774657',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'sUSDC',
    decimals: 6,
    name: 'Spicy USDC Vault',
    address: '0x1c4a802fd6b591bb71daa01d8335e43719048b24',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'ysUSDC',
    decimals: 6,
    name: 'Morpho Moonwell Flagship USDC Compounder',
    address: '0xd5428b889621eee8060fc105aa0ab0fa2e344468',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'eUSDC-1',
    decimals: 6,
    name: 'EVK Vault eUSDC-1',
    address: '0x0a1a3b5f2041f33522c4efc754a7d096f880ee16',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'mwUSDC',
    decimals: 18,
    name: 'Moonwell Flagship USDC',
    address: '0xc1256ae5ff1cf2719d4937adb3bbccab2e00a2ca',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'smUSDC',
    decimals: 18,
    name: 'Seamless USDC Vault',
    address: '0x616a4e1db48e22028f6bbf20444cd3b8e3273738',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'ysUSDC',
    decimals: 6,
    name: 'SuperUSDC',
    address: '0xe9f2a5f9f3c846f29066d7fb3564f8e6b6b2d65b',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'stataBasUSDC',
    decimals: 6,
    name: 'Static Aave Base USDC',
    address: '0x4ea71a20e655794051d1ee8b6e4a3269b13ccacc',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'hyUSD',
    decimals: 18,
    name: 'High Yield USD',
    address: '0xcc7ff230365bd730ee4b352cc2492cedac49383e',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'sUSDCy',
    decimals: 18,
    name: 'Synthetix USDC Yield',
    address: '0xc1e02884af4a283ca25ab63c45360d220d69da52',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'USD+',
    decimals: 6,
    name: 'USD+',
    address: '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'USDC+',
    decimals: 6,
    name: 'USDC+',
    address: '0x85483696cc9970ad9edd786b2c5ef735f38d156f',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'USDz',
    decimals: 18,
    name: 'USDz',
    address: '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'USDA',
    decimals: 18,
    name: 'USDA',
    address: '0x0000206329b97db379d5e1bf586bbdb969c63274',
    isDeposit: false,
    isStable: true,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'superOETHb',
    decimals: 18,
    name: 'Super OETH',
    address: '0xdbfefd2e8460a6ee4955a68582f85708baea60a3',
    isDeposit: false,
    isStable: false,
    chainId: 8453,
    tokenGroup: 'stable',
  },
  {
    symbol: 'WBTC',
    decimals: 8,
    name: 'Wrapped BTC',
    address: '0x0555e30da8f98308edb960aa94c0db47230d2b9c',
    isDeposit: false,
    isStable: false,
    chainId: 8453,
    tokenGroup: 'bluechip',
    coingeckoId: 'bitcoin',
  },
];

export const erc20TokensMap = vaultTokens.reduce(
  (acc, token) => {
    acc[token.address.toLowerCase() as `0x${string}`] = token;
    return acc;
  },
  {} as Record<`0x${string}`, VaultToken>
);

export const getVaultTokenByAddress = (
  address: `0x${string}`
): VaultToken | undefined =>
  erc20TokensMap[address.toLowerCase() as `0x${string}`];

export const getVaultTokenGroup = (
  token: VaultToken | undefined
): VaultToken['tokenGroup'] => token?.tokenGroup ?? 'altcoin';

export const mapAsUSDC = [
  '0x0d877dc7c8fa3ad980dfdb18b48ec9f8768359c4',
  '0xbc10718571fcb3c3f67800e7c0887e450d2ff398',
  '0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2',
  '0x0000206329b97db379d5e1bf586bbdb969c63274',
  '0x04d5ddf5f3a8939889f11e97f8c4bb48317f1938',
  '0x85483696cc9970ad9edd786b2c5ef735f38d156f',
  '0xb79dd08ea68a908a97220c76d19a6aa9cbde4376',
  '0xc1e02884af4a283ca25ab63c45360d220d69da52',
  '0xcc7ff230365bd730ee4b352cc2492cedac49383e',
  '0x4ea71a20e655794051d1ee8b6e4a3269b13ccacc',
  '0xe9f2a5f9f3c846f29066d7fb3564f8e6b6b2d65b',
  '0x616a4e1db48e22028f6bbf20444cd3b8e3273738',
  '0xc1256ae5ff1cf2719d4937adb3bbccab2e00a2ca',
  '0x0a1a3b5f2041f33522c4efc754a7d096f880ee16',
  '0xd5428b889621eee8060fc105aa0ab0fa2e344468',
  '0x1c4a802fd6b591bb71daa01d8335e43719048b24',
  '0x1d3b1cd0a0f242d598834b3f2d126dc6bd774657',
  '0xcddcdd18a16ed441f6cb10c3909e5e7ec2b9e8f3',
];

export interface StakingToken extends Token {
  chainId: number;
  tokenGroup: 'stable' | 'bluechip' | 'altcoin';
  coingeckoId?: string;
}

export const stakingTokens: StakingToken[] = [
  {
    symbol: 'SFI',
    name: 'Singularity Finance',
    decimals: 18,
    address: '0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'singularity-finance',
  },
  {
    symbol: 'SFI',
    name: 'Singularity Finance',
    decimals: 18,
    address: '0x7636D8722Fdf7cd34232a915E48e96aA3eB386BF',
    chainId: 56,
    tokenGroup: 'altcoin',
    coingeckoId: 'singularity-finance',
  },
  {
    symbol: 'FET',
    name: 'Fetch',
    decimals: 18,
    address: '0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'fetch-ai',
  },
  {
    symbol: 'RJV',
    name: 'Rejuve Token',
    decimals: 6,
    address: '0xa1f410f13B6007fCa76833ee7eb58478D47Bc5Ef',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'rejuve-ai',
  },
  {
    symbol: 'RJV',
    name: 'Rejuve Token',
    decimals: 6,
    address: '0x602B6C6ccE5F95c00603bd07D8fA7EbAF3747D44',
    chainId: 56,
    tokenGroup: 'altcoin',
    coingeckoId: 'rejuve-ai',
  },
  {
    symbol: 'NTX',
    name: 'NuNet Utility Token',
    decimals: 6,
    address: '0xF0d33BeDa4d734C72684b5f9abBEbf715D0a7935',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'nunet',
  },
  {
    symbol: 'SKYA',
    name: 'Sekuya',
    decimals: 18,
    address: '0x623cD3a3EdF080057892aaF8D773Bbb7A5C9b6e9',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'sekuya-2',
  },
  {
    symbol: 'SKYA',
    name: 'Sekuya',
    decimals: 18,
    address: '0x623cD3a3EdF080057892aaF8D773Bbb7A5C9b6e9',
    chainId: 8453,
    tokenGroup: 'altcoin',
    coingeckoId: 'sekuya-2',
  },
  {
    symbol: 'SOPH',
    name: 'SOPH AI Token',
    decimals: 18,
    address: '0x73fBD93bFDa83B111DdC092aa3a4ca77fD30d380',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'sophiaverse',
  },
  {
    symbol: 'SOPH',
    name: 'SOPH AI Token',
    decimals: 18,
    address: '0x73fBD93bFDa83B111DdC092aa3a4ca77fD30d380',
    chainId: 8453,
    tokenGroup: 'altcoin',
    coingeckoId: 'sophiaverse',
  },
  {
    symbol: 'GMRT',
    name: 'Gamertag Token',
    decimals: 18,
    address: '0x6967F0974d76d34e140caE27efeA32CDf546b58E',
    chainId: 8453,
    tokenGroup: 'altcoin',
    coingeckoId: 'gamer-tag',
  },
  {
    symbol: 'GNESS',
    name: 'Gameness Token',
    decimals: 18,
    address: '0x53Ffa52f358CCdB59c2a248D5D17AB91a32Ab44d',
    chainId: 56,
    tokenGroup: 'altcoin',
    coingeckoId: 'gameness-token',
  },
];

export interface MigrationToken extends Token {
  chainId: number;
  tokenGroup: 'stable' | 'bluechip' | 'altcoin';
  coingeckoId?: string;
}

export const migrationTokens: MigrationToken[] = [
  {
    symbol: 'SDAO',
    name: 'Singularity DAO',
    decimals: 18,
    address: '0x993864E43Caa7F7F12953AD6fEb1d1Ca635B875F',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'singularitydao',
  },
  {
    symbol: 'SDAO',
    name: 'Singularity DAO',
    decimals: 18,
    address: '0x90Ed8F1dc86388f14b64ba8fb4bbd23099f18240',
    chainId: 56,
    tokenGroup: 'altcoin',
    coingeckoId: 'singularitydao',
  },
  {
    symbol: 'CGV',
    name: 'Cogito',
    decimals: 18,
    address: '0x1bDaF9ddD7658d8049391971d1fd48c0484F66EC',
    chainId: 56,
    tokenGroup: 'altcoin',
    coingeckoId: 'cogito-protocol',
  },
  {
    symbol: 'CGV',
    name: 'Cogito',
    decimals: 18,
    address: '0xaeF420fd77477d9Dc8B46D704D44dD09d6c27866',
    chainId: 1,
    tokenGroup: 'altcoin',
    coingeckoId: 'cogito-protocol',
  },
];
